import moment from "moment";
import {PUBLIC_TRANSPORT_LIMIT_DATE} from "../constants";

export const ValidationRule = {
  required: {
    value: true,
    messageKey: 'requiredField',
  },
  patternLetters: {
    value:/^[\x00-\x7F\xA0-\xFF]+$///[^\u0000-\u00ff]+$/i///^[a-zA-ZÀ-ÿ \u05D0-\u05EA'-]+$/i//
  },
  specialCharacters: {
    value:/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
  },
  digits: {
    value: /^\d+$/,
    messageKey: 'errorInvalidNumberInput',
  },
  email: {
      value: /\S+@\S+\.\S+/,
    messageKey:'emailNotValid',
  },
  tz: {
    value: /^\d+$/,
    messageKey: 'InvalidId',
  },
  phone: {
    value: /^[\+\d]?(?:[\d-.\s()]*)$/,
    messageKey: 'InvalidPhoneNumber',
  },
};

export const addDays = (days) => {
  const newDate = new Date(new Date().getTime());
  newDate.setDate(newDate.getDate() + days);
  return newDate;
}

export  const  checkValidDate= (from ,to,check) => {

  var startDate   = moment(moment().format('YYYY-MM-DD'))
  var endDate     =  moment(moment().format('YYYY-MM-DD')).add(PUBLIC_TRANSPORT_LIMIT_DATE - 1, 'days')//moment("15/01/2013", "DD/MM/YYYY");
  var compareDate = moment(check, 'YYYY-MM-DD')
  return compareDate.isBetween(startDate, endDate,undefined, '[]'); //false in this case
}